import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Card from '../../components/Card'
import { db } from '../../data/firebase'
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  deleteDoc,
  doc
} from 'firebase/firestore'

import { Container } from './styles'
import { timeStampToBr } from '../../utils/dataUtils'

function AvisoAdm() {
  const navigate = useNavigate()
  const [data, setData] = useState([])

  useEffect(() => {
    const getAvisos = async () => {
      let list = []
      try {
        const avisosCollectionRef = collection(db, 'avisos')
        const q = query(
          avisosCollectionRef,
          orderBy('timeStamp', 'desc'),
          limit(100)
        )
        const snapshot = await getDocs(q)
        snapshot.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() })
        })
        setData(list)
      } catch (error) {
        alert(error.message)
      }
    }
    getAvisos()
  }, [])

  function handleNovo() {
    navigate('novo')
  }

  async function handleDelete(id) {
    try {
      await deleteDoc(doc(db, 'avisos', id))
      setData(data.filter((item) => item.id !== id))
    } catch (error) {
      alert(error.message)
    }
  }

  function handleEditar(aviso) {
    navigate('novo', { state: { obj: aviso } })
  }

  return (
    <Container>
      <div className="card-title">
        <h2>Avisos</h2>
      </div>
      <Card style={{ paddingTop: 20 }}>
        <button style={{ marginBottom: 20 }} onClick={handleNovo}>
          Novo
        </button>
        <table border={1}>
          <thead>
            <tr>
              <th>#</th>
              <th>Data</th>
              <th>Aviso</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {data.map((aviso, index) => (
              <tr key={aviso.id}>
                <td>{index + 1}</td>
                <td>{timeStampToBr(aviso.timeStamp)}</td>
                <td>{aviso.descricao}</td>
                <td>
                  <button onClick={() => handleEditar(aviso)}>Editar</button>
                  <button onClick={() => handleDelete(aviso.id)}>
                    Excluir
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </Container>
  )
}

export default AvisoAdm
